import { $bind } from "@/bind";
import { data } from "@/settings/data";

export class Shielding {
  // private blackMobile: (string | number)[] = [];
  // private blackEmail: string[] = [];
  // private blackEmailSuffix: string[] = [];
  // private blackCompany: string[] = [];

  constructor() {
    // this.blackMobile = data.mobile;
    // this.blackEmail = data.email;
    // this.blackEmailSuffix = data.email_suffix;
    // this.blackCompany = data.company;
    $bind.init();
    return this;
  }

  isAuth(s: string): boolean {
    const mobile = data.mobile.filter((d) => s == d)[0];
    if (mobile !== undefined) {
      return false;
    }
    const email = data.email.filter((d) => s == d)[0];
    if (email !== undefined) {
      return false;
    }
    const suffix = data.email_suffix.filter((d) => {
      const reg = new RegExp(d + "$", "i");
      return reg.test(s);
    })[0];
    console.log(suffix);
    return suffix === undefined;
  }

  isCompany(s: string): boolean {
    return !data.company.includes(s);
  }

  show(): void {
    $bind.show();
  }
}
